//import LoginPage from "./Pages/Login/Login";
//import LoginOrRegisterPage from "./Pages/LoginOrRegister/LoginOrRegister";
import React from "react";
import useMobileRoutes from "../Mobile/hooks/useMobileRoutes";
import { getClientType } from "../../utils";
import useDesktopRoutes from "../Desktop/hooks/useDesktopRoutes";
import { Link, useHistory as useReactRouterHistory } from "react-router-dom";
import MuiLink from "@material-ui/core/Link";
import { generatePath } from "react-router";
import { useLocation as useReactRouterUseLocation } from "react-router";
import useDesktopUseLocation from "../hooks/useLocation";

// We add this as a hook so we can implement localization later:
const useRoutes = () => {
  const mobileRoutes = useMobileRoutes();
  const desktopRoutes = useDesktopRoutes();

  if (getClientType() == "mobilev2") {
    return mobileRoutes;
  } else {
    return desktopRoutes;
  }
};

export const useLocation = () => {
  if (getClientType() == "mobilev2") {
    return useReactRouterUseLocation();
  }
  return useDesktopUseLocation();
};

export const getLinkComponentAttributes = (
  path,
  routes,
  keepExistingParms = false
) => {
  let variables = {};
  console.log("Path", path, routes);
  if (typeof path === "object") {
    variables = path.variables;
    path = path.path;
  }

  console.log("Out path", path, variables);

  if (getClientType() == "mobilev2") {
    console.log("Variables", variables);
    return {
      component: Link,
      to: generatePath(routes[path].path, variables),
    };
  } else {
    let newPath = generatePath(routes[path].path, variables);
    if (keepExistingParms) {
      let urlObj = new URL(
        document.location.protocol + document.location.hostname + newPath
      );
      const newSearchParams = urlObj.searchParams;
      let currentUrlParams = new URLSearchParams(document.location.search);
      for (const urlParam of currentUrlParams) {
        if (newSearchParams.has(urlParam[0])) {
          continue;
        }
        console.log("Variable is", urlParam[0]);
        newSearchParams.set(urlParam[0], urlParam[1]);
      }
      newPath = urlObj.toString();
      console.log("New path is", newPath);
    }
    return {
      component: "a",
      href: newPath,
    };
  }
};

export const useHistory = () => {
  const reactRouterHistory = useReactRouterHistory();
  if (getClientType() == "mobilev2") {
    return reactRouterHistory;
  }
  return {
    push: (target) => {
      document.location.href = target;
    },
    replace: (target) => {
      history.replaceState(null, null, target);
    },
  };
};

export default useRoutes;
